import React, {useState, useEffect} from 'react';
import {CorporationSearchForm, UrlUtil, FieldContainer, TextInput} from "@graffer-inc/graffer-ui";
import Http from '../../../http';
import Format from '../../../utils/format';
import ErrorHandler from '../../../utils/error-handler';
import Transition from '../../../utils/transition';
import {connect} from "react-redux";
import {setLoginAccount} from "../../../redux/modules/user";
import { toast } from 'react-toastify';
import PreSettingDone from '../../templates/pre-setting-done';
import SubTitle from '../../atoms/sub-title';
import {Link} from "react-router-dom";
import * as store from "store";
import Const from "../../../constants";

const Main = ({setLoginAccount, loginAccount}) => {

  // 法人自体を変更するモードかどうか
  const [isCorporationChangeMode, setIsCorporationChangeMode] = useState(false);
  // 設定された法人の国税庁APIの本店所在地
  const [corporateAddress, setCorporateAddress] = useState(null);
  // ユーザーが設定した本店所在地
  const [corporateAddressSetByUser, setCorporateAddressSetByUser] = useState(null);
  // 入力情報管理用の本店所在地
  const [address, setAddress] = useState('');
  const [corporation, setCorporation] = useState(null);
  const [isRequesting, setIsRequesting] = useState(false);

  const searchCorporations = async (corporateId) => Http.searchCorporations(
    corporateId,
    async res => {
      const corporateAddress = res.data.data[0].pref + res.data.data[0].city + res.data.data[0].street;
      setCorporateAddress(corporateAddress);
      await Http.fetchCorporateAddressSetByUser(
        res2 => {
          setCorporateAddressSetByUser(res2.data.corporateAddress ? res2.data.corporateAddress.value : null);
          setAddress(res2.data.corporateAddress ? res2.data.corporateAddress.value : corporateAddress);
        },
      )
    },
  );

  useEffect(() => {
    searchCorporations(loginAccount.company.corporateId);
  }, [loginAccount]);

  const { to } = UrlUtil.parseQueryOf(window.location.search);
  const updateCompany = async () => {
    setIsRequesting(true);
    await Http.updateCompany(
      {corporateId: corporation.id, companyName: corporation.name},
      async () => {
        await Http.fetchLoginAccount(async res => {
            const loginAccount = res.data.isAuthed ? res.data : null;
            setLoginAccount(loginAccount);
            if (!loginAccount) {
              store.set(Const.STORAGE.ACCESS_PATH, window.location.pathname + window.location.search);
              await Http.logout();
              Transition.goToLogin();
            }
          },
          () => {
            store.set(Const.STORAGE.ACCESS_PATH, window.location.pathname + window.location.search);
            Transition.goToLogin();
          });
        if (corporateAddressSetByUser) {
          await Http.deleteCorporateAddressSetByUser(
            () => {
              setIsRequesting(false);
              toast.success('自社を変更しました。');
              Transition.goTo(to || '/home');
            },
            () => {
              setIsRequesting(false);
              toast.success('自社を変更しました。');
              Transition.goTo(to || '/home');
            },
          );
        } else {
          setIsRequesting(false);
          toast.success('自社を変更しました。');
          Transition.goTo(to || '/home');
        }
      },
      e => {
        setIsRequesting(false);
        ErrorHandler.common(e.response.status);
      },
    )
  };  const upsertCorporateAddressSetByUser = async () => {
    setIsRequesting(true);
    await Http.upsertCorporateAddressSetByUser(
      {corporateAddress: address},
      () => {
        toast.success('本店所在地を変更しました。');
        Transition.goTo(to || '/home');
      },
      e => {
        setIsRequesting(false);
        ErrorHandler.common(e.response.status);
      },
    )
  };
  return (
    <PreSettingDone>
      <div className="container">
        <div className="columns is-centered">
          <div className="column is-7">
            <p className="is-size-3 has-text-weight-bold">自社設定の変更</p>
            <p className="is-size-7">自社は1アカウントごとに1つとなります。複数法人の電子証明書をお求めの方は別途アカウントを作成してください。</p>
            {
              isCorporationChangeMode ? (
                <p className="is-size-7">法人を検索して再設定してください。前の画面に戻す場合は
                  {/* eslint-disable-next-line */}
                  <a  onClick={() => {
                    setIsCorporationChangeMode(false);
                  }}>
                    こちら
                  </a>
                  を押してください。</p>
              ) : (
                <p className="is-size-7">設定した法人の登記変更（法人名・本店所在地）をされた場合、または設定した法人に誤りがあり、別の法人を設定したい場合は
                  {/* eslint-disable-next-line */}
              <a onClick={() => {
                  setIsCorporationChangeMode(true);
                }}>こちら</a>から法人を検索して再設定してください。</p>
              )
            }
            <br/>
            <br/>
            {
              !isCorporationChangeMode && (
                <div style={{padding: '0 0 50px 0'}}>
                  <SubTitle>設定されている法人</SubTitle>
                  <FieldContainer name="法人名">
                    {loginAccount.company.companyName}
                  </FieldContainer>
                  <FieldContainer name="法人番号">
                    {loginAccount.company.corporateId} / {Format.corporateNumber(loginAccount.company.corporateId)}
                  </FieldContainer>
                  {
                    corporateAddressSetByUser && (
                      <FieldContainer name="元の本店所在地">
                        {corporateAddress}
                      </FieldContainer>
                    )
                  }
                  <FieldContainer name="登記した本店所在地">
                    <TextInput value={address} onChange={v => setAddress(v)} noValidate/>
                    <p className="is-size-7">はじめに設定された入力内容は、国税庁のシステムのデータを使用しています。ほとんどの場合、登記どおりの本店所在地が表示されますが、「都道府県なしでの登記」や「丁目の漢数字での登記」などは変更が必要な場合があります。</p>
                  </FieldContainer>
                </div>
              )
            }
            {
              isCorporationChangeMode && (
                <div style={{padding: '0 0 50px 0'}}>
                  <CorporationSearchForm initKeyword={loginAccount.company && loginAccount.company.companyName} onSelect={c => setCorporation(c)}/>
                  {
                    corporation && (
                      <div className="message" style={{marginTop: '25px', padding: '20px 10px', position: 'relative'}}>
                        <span style={{position: 'absolute', top: -10, left: 0}} className="tag is-rounded is-dark">選択した法人</span>
                        <p className="is-size-5 is-size-6-mobile has-text-weight-bold">{corporation.name}</p>
                        <p className="is-size-7">法人番号: {corporation.id} / {Format.corporateNumber(corporation.id)}</p>
                        <p className="is-size-7">本店所在地: {corporation.postal_code} {corporation.pref}{corporation.city}{corporation.street}</p>
                      </div>
                    )
                  }
                </div>
              )
            }

            {
              isCorporationChangeMode ? (
                <div className="is-flex">
                  <button
                    className={`button is-info is-fullwidth is-rounded ${isRequesting && 'is-loading'}`}
                    onClick={updateCompany}
                    disabled={!corporation || isRequesting}
                  >
                    法人を変更する
                  </button>
                  <div style={{ padding: "0px 5px" }}></div>
                  <Link
                    to={to || '/home'}
                    className="button is-text is-rounded is-fullwidth is-outlined"
                  >
                    {to ? '前の画面' : 'ホーム'}に戻る
                  </Link>
                </div>
              ) : (
                <div className="is-flex">
                  <button
                    className={`button is-info is-fullwidth is-rounded ${isRequesting && 'is-loading'}`}
                    onClick={upsertCorporateAddressSetByUser}
                    disabled={!address || isRequesting}
                  >
                    本店所在地を変更する

                  </button>
                  <div style={{ padding: "0px 5px" }}></div>
                  <Link
                    to={to || '/home'}
                    className="button is-text is-rounded is-fullwidth is-outlined"
                  >
                    {to ? '前の画面' : 'ホーム'}に戻る
                  </Link>
                </div>
              )
            }
          </div>
        </div>
      </div>
    </PreSettingDone>
  )
};

export default connect(
  store => ({ loginAccount: store.user.loginAccount }),
  {setLoginAccount}
)(Main);